import { render, staticRenderFns } from "./raw-data-table.vue?vue&type=template&id=bd2b2e0a&"
import script from "./raw-data-table.vue?vue&type=script&lang=ts&"
export * from "./raw-data-table.vue?vue&type=script&lang=ts&"
import style0 from "./raw-data-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports